export const GA_Push = (action, label) => {
  if (label) {
    var data = {
      event: "GA_Event",
      Category: "Lead Form",
      Action: action,
      Label: label,
    };
  } else {
    var data = {
      event: "GA_Event",
      Category: "Lead Form",
      Action: action
    };
  }
  window.dataLayer.push(data);
};
